import React, { useEffect, useState } from "react";
import LoginView from "./LoginView";
import { Form } from "antd";
import axios from "axios";
import { useDispatch } from "react-redux";
import { login } from "../../reducer/app";
import { useHistory } from "react-router-dom";

const Login = (props) => {
  const [isRegistered, setIsRegistered] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [schools, setSchools] = useState([]);
  const [classLevel, setClassLevel] = useState([]);
  const [schoolSelectable, setSchoolSelectable] = useState(false);
  const [show2FAVerifyModal, setShow2FAVerifyModal] = useState(false);
  const [foundUser, setFoundUser] = useState(false);
  const [last4Digits, setLast4Digits] = useState("");
  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    axios
      .get("/api/common/loadIndex")
      .then((response) => {
        setSchoolSelectable(response.data.data.schoolSelectable === 1);
        const schoolList = response.data.data.schools.map((val) => ({
          value: val.id,
          label: val.schoolName,
        }));
        setSchools([{ value: 0, label: "Diğer" }, ...schoolList]);
        const classLevel = response.data.data.classLevel.map((val) => ({
          value: val.id,
          label: val.description,
        }));
        setClassLevel(classLevel);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const verify2FA = () => {
    setShow2FAVerifyModal(true);
  };

  const handleVerify2FA = (result) => {
    if (result) {
      setShow2FAVerifyModal(false);
      if (isRegistered) {
        dispatch(login({ user: foundUser }));
        history.push("/ana-sayfa");
      } else {
        // just registering from form
        form.submit();
      }
    }
  };

  const onFinish = (values) => {
    const url = isRegistered ? "/api/auth/login" : "/api/auth/register";

    setIsLoading(true);
    axios
      .post(url, values)
      .then(async (response) => {
        if (!response.data?.data?.user) {
          setIsRegistered(false);
        } else {
          if (response.data.msg.includes("tekrar deneyiniz")) {
            return;
          }
          if (response.data.data.isRegistering) {
            dispatch(login({ user: response.data.data.user }));
            history.push("/ana-sayfa");
          } else {
            setFoundUser(response.data.data.user);
            setLast4Digits(response.data.data.last4Digits);
            verify2FA();
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <LoginView
      form={form}
      onFinish={onFinish}
      isRegistered={isRegistered}
      isLoading={isLoading}
      schools={schools}
      classLevel={classLevel}
      schoolSelectable={schoolSelectable}
      show2FAVerifyModal={show2FAVerifyModal}
      setShow2FAVerifyModal={setShow2FAVerifyModal}
      handleVerify2FA={handleVerify2FA}
      last4Digits={last4Digits}
    />
  );
};

export default Login;
